import request from './index';

export function getMessages(params) {
  return request.get('officialMessage/page', {
    params: params
  });
}